var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chapter",style:({ display: _vm.visible ? 'block' : 'none' }),attrs:{"id":'chapter_' + _vm.chapter.chapterNumber}},_vm._l((_vm.pages),function(ref,index){
var pageNumber = ref.pageNumber;
var content = ref.content;
return _c('Pages',{key:index,attrs:{"page-number":pageNumber,"content":content,"visible":_vm.currentPage === pageNumber,"resource":_vm.resource}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }